import { BaseUrl } from "@/config";
import { createCollectibleLink, createPublicItemDetailLink } from "@/router";
import { fetchCategoryById } from "@/services/collection/categories";
import { isCreatedFromCollectible, type PublicCollectionItem } from "@/services/collection/item/public";
import { createPageTitle } from "@/services/metaTags";
import { computedAsync } from "@vueuse/core";
import type { Ref } from "vue";
import { readonly } from "vue";
import { useRouter } from "vue-router";

export function usePublicCollectionItemMeta(item: Ref<PublicCollectionItem | undefined>) {
  const router = useRouter();

  const canonical = computedAsync(async () => {
    const i = item.value;

    if (i === undefined) {
      return undefined;
    } else if (isCreatedFromCollectible(i)) {
      const category = await fetchCategoryById(i.categoryId);
      const collectibleId = i.collectible.id;
      const link = createCollectibleLink(category, collectibleId);
      const url = BaseUrl + router.resolve(link).href;
      return url;
    } else {
      const link = createPublicItemDetailLink(i.id, i.name, i.collectorNickname);
      const url = BaseUrl + router.resolve(link).href;
      return url;
    }
  });

  const title = computed(() => {
    if (item.value === undefined) {
      return "";
    } else {
      return createPageTitle(item.value.name);
    }
  });

  return {
    canonical: readonly(canonical),
    title: readonly(title),
  };
}
